export default function formatPhone(phone) {
  let ph = phone.toString();

  ph = ph.replace(/[/+()_-]*/g, '').replace(/\s/g, '');

  if (ph.length == 11) {
    let pattern = new RegExp(
      `(^\\d{${ph.length % 10}})(\\d{3})(\\d{3})(\\d{2})(\\d{2}$)`,
    );

    ph = ph.replace(pattern, '+$1 ($2) $3-$4-$5');

    return ph;
  }

  return phone;
}
